<template>
  <div class="lable_table">
    <el-table :key="key" :data="lableTable" border highlight-current-row
      height="100%" row-key="relaId" @row-click="rowClick" @selection-change="handleSelectionChange">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size: 16px; color: #000; margin-top: 36px">
          暂无数据
        </p>
      </template>
      <template>
        {{ type }}
      </template>
      <template v-if="type==1">
        <el-table-column type="selection" align="center" width="42" header-align="center" reserve-selection />
        <el-table-column label="姓名" prop="name" align="center" min-width="120px" />
        <el-table-column label="性别" prop="sex" align="center" min-width="80">
          <template #default="{row}">
            <span v-if="row.sex=='1'">男</span>
            <span v-if="row.sex=='2'">女</span>
          </template>
        </el-table-column>
        <el-table-column label="所属部门" prop="deptList" min-width="300px" align="center">
          <template #default="{row}">
            <el-popover v-if="isShow(row)" trigger="hover" placement="top" popper-class="deptNamePopperStyle">
              <div class="name-wrapper">
                <div v-for="(name,index) in row.deptList" :key="index" class="deptName">
                  <p class="icon"></p>
                  <p class="fullDeptName">
                    {{ name.fullDeptName }}
                  </p>
                </div>
              </div>
              <div slot="reference" class="name-wrapper">
                <span v-for="(name,index) in row.deptList" :key="index" class="deptName">{{ name.deptName }}</span>
              </div>
            </el-popover>
            <div v-else class="name-wrapper">
              <span v-for="(name,index) in row.deptList" :key="index" class="deptName">{{ name.deptName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="账号" prop="username" align="center" min-width="120px" />
      </template>
      <template v-else>
        <el-table-column type="selection" align="center" width="42" header-align="center" reserve-selection />
        <el-table-column label="部门名称" prop="deptName" align="center" min-width="120px" />
        <el-table-column label="部门编号" prop="deptCode" align="center" min-width="80" />
        <el-table-column label="路径" prop="fullDeptName" align="center" min-width="80" />
      </template>
    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    lableTable: { type: Array, required: true },
    type: { type: Number, required: false, default: 0 } // 1包含人员 2包含部门
  },
  data() {
    return {
      selectedRows: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      key: 1
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    type() {
      this.key++;
    }
  },
  created() {},
  methods: {
    isShow(row) {
      if (row.deptList && row.deptList.length > 0) {
        const show = row.deptList.find(({ fullDeptName }) => fullDeptName !== null);
        if (show) return true;
        else return false;
      }
    },
    rowClick(val) {
      this.$emit("lableHandleChange", val);
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
      this.$emit("lableRowsSelected", this.selectedRows);
    }
  }
};
</script>

<style lang="scss">
.el-popover.deptNamePopperStyle {
  background: linear-gradient(304.17deg, rgba(244, 250, 255, 0.6) -6.04%, rgba(247, 249, 255, 0.6) 85.2%);
  box-shadow: 0px 4px 7px rgba(224, 224, 224, 0.48);
  backdrop-filter: blur(5px);
  border-radius: 6px;
  .name-wrapper{
    .icon{
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: var(--theme-color);
      display: inline-block;
      margin-right: 10px;
    }
    .deptName{
      width: 218px;
      min-height: 32px;
      color: #4E5969;
      padding: 0px 6px;
      margin-bottom: 6px;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 6px 0px 20px rgba(34, 87, 188, 0.1);
      border-radius: 4px;
      display: flex;
      align-items: center;
    }
    .fullDeptName{
      width: 192px;
    }
  }
}
</style>
<style lang="scss" scoped>
.lable_table {
  height: 100%;
  .name-wrapper{
    .deptName{
      background: rgba(47, 141, 251, 0.05);
      border: 1px solid var(--theme-color);
      border-radius: 2px;
      color: var(--theme-color);
      padding: 2px 10px;
      margin-right:5px;
      display: inline-block;
      margin-bottom: 2px;
    }
  }
}
</style>
